const state = {
  isLogin: false,
  userInfo: null,
};

export default state;
